import React, { useRef, useState, useContext } from 'react';
import { FaFilePdf } from 'react-icons/fa';
import './input.css';
import { ReactComponent as PDF } from '../../assets/IconsColurs/IconsGeneral/pdf.svg'
import { ReactComponent as TRASH } from '../../assets/IconsColurs/IconsGeneral/trash.svg'

import ColorsMain from '../../colors/ColorsMain';
import { GLOBAL_LANGUAGE } from "../../language/language";
import { UtilContext } from "../../context/UtilContext";


const UploadPDF = ({ error = false, setUploadedFile, uploadedFile, readOnly = false, showDelect = true }) => {
    const fileInputRef = useRef(null);
    const [isDragging, setIsDragging] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    const { language } = useContext(UtilContext);
    const t = GLOBAL_LANGUAGE[language] || GLOBAL_LANGUAGE.es;

    React.useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleClick = () => {
        fileInputRef.current.click();
    };
    const deletePDF = () => {
        setUploadedFile(null)
    };

    const handleFileChange = (event) => {


        const file = event.target.files[0];
        processFile(file);
    };

    const processFile = (file) => {
        if (file && file.type === "application/pdf" && file.size <= 15 * 1024 * 1024) {
            console.log("Archivo subido correctamente:", file);
            setUploadedFile(file);
        } else {
            alert(t.upload_pdf.alert_pdf);
        }
    };

    const handleDragOver = (event) => {
        event.preventDefault();
        setIsDragging(true);
    };

    const handleDragLeave = () => {
        setIsDragging(false);
    };

    const handleDrop = (event) => {
        event.preventDefault();
        setIsDragging(false);
        const file = event.dataTransfer.files[0];
        processFile(file);
    };
    function getFileNameFromURL(url) {
        // Usamos split para dividir por "/" y obtener el último segmento
        return url.split('/').pop();
    }
    return (
        <>
            {uploadedFile &&
                <div
                    className={`file-upload-container-complete mb-2 ${isDragging ? 'dragging' : ''}`}
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                    onDrop={handleDrop}
                    style={{
                        borderColor: error ? ColorsMain.errorBorder : 'white',
                        borderWidth: 2
                    }}
                >
                    <div className="file-preview md:flex-row md:justify-start flex items-center justify-between w-full px-3 py-2 md:p-0" onClick={readOnly ? null : handleClick}>
                        <div className='flex md:block items-center gap-3 md:gap-0 md:w-1/5'>
                            <PDF width={32} height={32} className="file-icon-preview md:w-12 md:h-12 w-8 h-8" />
                        </div>

                        <div className="file-details md:w-3/5">
                            {uploadedFile?.name && (
                                <p className="file-name text-sm md:text-base text-[#B7B7B9] md:text-white">
                                    {uploadedFile?.name?.slice(0, 20)}...
                                </p>
                            )}
                            {uploadedFile.name === undefined && (
                                <p className="file-name text-sm md:text-base text-[#B7B7B9] md:text-white">
                                    {getFileNameFromURL(uploadedFile).slice(0, 20)}...
                                </p>
                            )}
                            <button className="file-reupload text-xs md:text-sm text-[#8A8A8E] md:text-white">
                                {readOnly ? t.upload_pdf.read_only : t.upload_pdf.change_file}
                            </button>
                        </div>

                        {showDelect && (
                            <div className='md:flex md:justify-center md:flex-col md:items-center md:p-0 flex flex-col items-center justify-center cursor-pointer' onClick={() => deletePDF()}>
                                <TRASH width={24} height={24} className="file-icon-preview md:w-7 md:h-7" />
                                <p className='text-xs md:text-sm text-[#8A8A8E] md:text-white'>delete</p>
                            </div>
                        )}
                    </div>

                    <input
                        readOnly={readOnly}
                        type="file"
                        ref={fileInputRef}
                        style={{ display: 'none' }}
                        onChange={handleFileChange}
                        accept=".pdf"
                    />
                </div>}
            {!uploadedFile &&
                <div
                    className={`file-upload-container w-full mb-2 ${isDragging ? 'dragging' : ''}`}
                    onClick={handleClick}
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                    onDrop={handleDrop}
                    style={{
                        borderColor: error ? ColorsMain.errorBorder : '#4a4a4a',
                        borderWidth: 2
                    }}
                >
                    <div className='md:p-8 p-3 flex flex-col md:flex-row items-center justify-center gap-2 md:gap-0'>
                        <div className='flex items-center justify-center'>
                            <PDF width={32} height={32} className="file-upload-icon md:w-12 md:h-12 w-8 h-8 md:mr-4" />
                        </div>
                        <div className='flex flex-col items-center md:items-start'>
                            <p className="file-upload-text text-center md:text-left text-sm md:text-base">
                                {isMobile ? (
                                    <span>
                                        {language === 'es' ? 'Haz clic aquí para subir archivo' : 'Click here to upload file'}
                                    </span>
                                ) : (
                                    <>
                                        {t.upload_pdf.title} <span className="file-upload-link">{t.upload_pdf.click}</span>
                                    </>
                                )}
                            </p>
                            <span className="file-size-note text-xs md:text-sm text-center md:text-left">
                                {language === 'es' ? 'Formato PDF (máx. 15.0 MB)' : 'PDF Format (max. 15.0 MB)'}
                            </span>
                        </div>
                    </div>

                    <input
                        type="file"
                        ref={fileInputRef}
                        style={{ display: 'none' }}
                        onChange={handleFileChange}
                        accept=".pdf"
                    />
                </div>}
        </>


    );
};

export default UploadPDF;
